import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarCndDs,
  criarConfiguracaoCndDs,
  criarContribuinteDs,
  criarImovelDs,
  criarCpbsDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import CpbsBox from "../cpbs/CpbsBox";
import ImovelBox from "../imovel/ImovelBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ShowError from "../../AppServices";
import api from "../../api-axios";
import { LoadIndicator } from "devextreme-react/load-indicator";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  contribuinteId: undefined,
  imovelId: undefined,
  cpbsId: undefined,
  tipoDeCertidaoId: undefined,
  ano: undefined,
  numero: undefined,
  data: new Date(),
  tipoCadastro: "C",
  validade: undefined,
  observacao: "",
  permitirDuplicidade: true,
  popupVisivel: false,
  _uiCarregando: true,
  _uiNumero: "",
  _uiTipoCadastro: "C",
  _uiLegendaTipoCadastro: "Contribuinte",

};

export default class CertidaoNegativaForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.cndDs = criarCndDs();
    this.contribuinteDs = criarContribuinteDs();
    this.imovelDs = criarImovelDs();
    this.cpbsDs = criarCpbsDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.tiposCadastroDs = [
      { id: "C", descricao: "Contribuinte" },
      { id: "E", descricao: "CPBS" },
      { id: "I", descricao: "Imóvel" },
    ];

    this.onTipoCertidaoAlterado = this.onTipoCertidaoAlterado.bind(this);

    this.tipoDeCertidaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: criarConfiguracaoCndDs(),
      onSelectionChanged: this.onTipoCertidaoAlterado,
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
    };

    this.tipoCadastroOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: this.tiposCadastroDs,
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) =>
        this.setState({
          tipoCadastro: e.value,
          _uiNome: "",
          inputId: undefined,
        }),
    };

    this.duplicidadeOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" }
      ],
      valueExpr: "id",
      displayExpr: "descricao"
    };

    //Funções do input
    /*
    /*
    */
    this.setInputId = this.setInputId.bind(this);
    this.pesquisarRegistro = this.pesquisarRegistro.bind(this);
    this.onRegistroSelecionadoPesquisa =
      this.onRegistroSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.cpbsBoxRef = React.createRef();
    this.imovelBoxRef = React.createRef();
    this.renderInput = sysCodigoDescricao(
      () => {
        if (this.state._uiTipoCadastro == "C") {
          return this.state.contribuinteId;
        } else if (this.state._uiTipoCadastro == "I") {
          return this.state.imovelId;
        } else if (this.state._uiTipoCadastro == "E") {
          return this.state.cpbsInscricao;
        }
      },
      this.setInputId,
      () => {
        let result;
        if (this.state._uiTipoCadastro == "C") {
          result = this.state._uiNomeContribuinte;
        } else if (this.state._uiTipoCadastro == "I") {
          result = this.state._uiNomeImovel;
        } else if (this.state._uiTipoCadastro == "E") {
          result = this.state._uiNomeCpbs;
        }
        return result;
      },
      this.pesquisarRegistro
    );
    this.setNomeErro = this.setNomeErro.bind(this);
    /*
   /*
   */
    //Fim da funções do input
  }

  //Funções do input
  /*
  /*
  */

  onTipoCertidaoAlterado(e) {
    const tipo = e.selectedItem;
    let tipoCadastro;
    let legendaTipoCadastro = "Contribuinte";
    let validade;

    if (tipo != undefined) {
      tipoCadastro = tipo.tipoCadastro.codigo;
      validade = tipo.validade;
    }

    if (tipoCadastro == "C") {
      legendaTipoCadastro = "Contribuinte";
    } else if (tipoCadastro == "I") {
      legendaTipoCadastro = "Imóvel";
    } else if (tipoCadastro == "E") {
      legendaTipoCadastro = "Empresa";
    }

    this.setState({
      tipoDeCertidaoId: tipo.id,
      _uiTipoCadastro: tipoCadastro,
      _uiLegendaTipoCadastro: legendaTipoCadastro,
      validade: validade,
    });
  }

  setInputId(data) {
    let estado = {};
    Object.assign(estado, this.state);
    switch (this.state._uiTipoCadastro) {
      case "C":
        this.contribuinteDs
          .load({ filter: [["sequencial", "=", data.value]] })
          .then((result) => {
            if (result.length !== 0) {
              if (result[0] === undefined) {
                Object.assign(estado, { _uiNomeContribuinte: "" });
              } else {
                Object.assign(estado, { _uiNomeContribuinte: result[0].nome });
              }
            } else {
              Object.assign(estado, { _uiNomeContribuinte: "" });
            }
            this.setState({
              ...estado,
              contribuinteId: data.value,
              popupVisivel: false,
            });
          })
          .catch((_) => this.setNomeErro());
        break;
      case "E":
        this.cpbsDs
          .load({ filter: [["inscricao", "=", data.value]] })
          .then((result) => {
            if (result.length !== 0) {
              if (result[0] === undefined) {
                Object.assign(estado, { _uiNomeCpbs: "" });
              } else {
                Object.assign(estado, {
                  _uiNomeCpbs: result[0].contribuinte.nome,
                });
              }
            } else {
              Object.assign(estado, { _uiNomeCpbs: "" });
            }
            this.setState({
              ...estado,
              cpbsInscricao: data.value,
              popupVisivel: false,
            });
          })
          .catch((_) => this.setNomeErro());
        break;
      case "I":
        this.imovelDs
          .load({ filter: [["sequencial", "=", data.value]] })
          .then((result) => {
            if (result.length !== 0) {
              if (result[0] === undefined) {
                Object.assign(estado, { _uiNomeImovel: "" });
              } else {
                Object.assign(estado, {
                  _uiNomeImovel: result[0].enderecoCompleto,
                });
              }
            } else {
              Object.assign(estado, { _uiNomeImovel: "" });
            }
            this.setState({
              ...estado,
              imovelId: data.value,
              popupVisivel: false,
            });
          })
          .catch((_) => this.setNomeErro());
        break;
    }
  }

  setNomeErro() {
    this.setState({ _uiNome: "<<ERRO>>" });
  }

  onRegistroSelecionadoPesquisa(e) {
    if (this.state._uiTipoCadastro == "C") {
      this.setState({
        contribuinteId: e.row.data.sequencial,
        _uiNomeContribuinte: e.row.data.nome,
        popupVisivel: false,
      });
    } else if (this.state._uiTipoCadastro == "I") {
      this.setState({
        imovelId: e.row.data.sequencial,
        _uiNomeImovel: e.row.data.enderecoCompleto,
        popupVisivel: false,
      });
    } else if (this.state._uiTipoCadastro == "E") {
      this.setState({
        cpbsInscricao: e.row.data.inscricao,
        _uiNomeCpbs: e.row.data.contribuinte.nome,
        popupVisivel: false,
      });
    }
  }

  pesquisarRegistro() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.cpbsBoxRef.current.limparFiltro();
    //this.imovelBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }

  /*
/*
*/
  //Fim da funções do input

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.cndDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("CND não encontrado.", "error");
              this.props.history.push("/certidaonegativa");
            }
            const contribuinteId =
              data.contribuinte == undefined
                ? undefined
                : data.contribuinte.sequencial;
            const imovelId =
              data.imovel == undefined ? undefined : data.imovel.sequencial;
            const cpbsInscricao =
              data.cpbs == undefined ? undefined : data.cpbs.inscricao;

            const _uiNomeContribuinte =
              data.contribuinte == undefined
                ? undefined
                : data.contribuinte.nome;
            const _uiNomeCpbs =
              data.cpbs == undefined ? undefined : data.cpbs.contribuinte.nome;
            const _uiNomeImovel =
              data.imovel == undefined
                ? undefined
                : data.imovel.enderecoCompleto;

            const novoEstado = {
              id: data.id,
              prefeituraId: data.prefeituraId,
              contribuinteId: contribuinteId,
              imovelId: imovelId,
              cpbsInscricao: cpbsInscricao,
              tipoDeCertidaoId: data.tipoDeCertidaoId,
              ano: data.ano,
              numero: data.numero,
              data: data.data,
              tipoCadastro: data.tipoDeCertidao.tipoCadastro.codigo,
              validade: data.validade,
              observacao: data.observacao,
              permitirDuplicidade: true,
              popupVisivel: false,
              _uiNumero: data.numeroCompleto,
              _uiTipoCadastro: data.tipoDeCertidao.tipoCadastro.codigo,
              _uiLegendaTipoCadastro:
                data.tipoDeCertidao.tipoCadastro.descricao,
              _uiNomeContribuinte,
              _uiNomeCpbs,
              _uiNomeImovel,
              _uiCarregando: false
            };

            this.setState(novoEstado);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
      else {
        api.get(`cnds/start/${UserInfo.getPrefeitura()}`)
          .then(resp => {
            this.setState({
              ...template,
              permitirDuplicidade: resp.data.permitirDuplicidade,
              _uiCarregando: false
            });
          })
          .catch(error => {
            console.log(error)
            notify("Erro ao obter dados do servidor", "error");
            this.props.history.goBack();
          });
      }
    }
    else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {

    if (this.state._uiCarregando) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <LoadIndicator width={60} height={60} />
          </div>
        </div>
      );
    }


    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem caption="CERTIDÃO NEGATIVA" colSpan={2} colCount={4}>
              <SimpleItem
                dataField={"_uiNumero"}
                colSpan={1}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Número" />
              </SimpleItem>
              <EmptyItem colSpan={3} />
              <SimpleItem
                dataField={"tipoDeCertidaoId"}
                editorType={"dxLookup"}
                editorOptions={this.tipoDeCertidaoOptions}
                colSpan={4}
              >
                <Label text="Tipo de Certidão" />
              </SimpleItem>
              <SimpleItem colSpan={4} component={this.renderInput}>
                <Label text={`${this.state._uiLegendaTipoCadastro}`} />
              </SimpleItem>
              <SimpleItem
                dataField={"data"}
                colSpan={1}
                editorType="dxDateBox"
                editorOptions={{ width: "100%" }}
              >
                <Label text="Data" />
              </SimpleItem>
              <EmptyItem colSpan={3} />
              <SimpleItem
                dataField={"validade"}
                colSpan={1}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Validade" />
              </SimpleItem>
              <EmptyItem colSpan={3} />
              <SimpleItem
                dataField={"permitirDuplicidade"}
                colSpan={1}
                editorType={"dxSelectBox"}
                editorOptions={this.duplicidadeOptions}
              >
                <Label text="Duplicidade" />
              </SimpleItem>
              <EmptyItem colSpan={3} />
              <SimpleItem
                dataField={"observacao"}
                colSpan={4}
                editorType={"dxTextArea"}
                editorOptions={{ height: "120px" }}
              >
                <Label text="Observação" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="danger"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.popupVisivel}
          onHiding={() => this.setState({ popupVisivel: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar"
        >
          <ScrollView showScrollbar={"always"}>
            <div
              style={{
                display: this.state._uiTipoCadastro === "C" ? "" : "none",
              }}
            >
              <ContribuinteBox
                onSelecionado={this.onRegistroSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </div>
            <div
              style={{
                display: this.state._uiTipoCadastro === "E" ? "" : "none",
              }}
            >
              <CpbsBox
                onSelecionado={this.onRegistroSelecionadoPesquisa}
                ref={this.cpbsBoxRef}
              />
            </div>
            <div
              style={{
                display: this.state._uiTipoCadastro === "I" ? "" : "none",
              }}
            >
              <ImovelBox
                onSelecionado={this.onRegistroSelecionadoPesquisa}
              //ref={this.imovelBoxRef}
              />
            </div>
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    // switch (this.state.tipoCadastro) {
    //   case "C":
    //     Object.assign(entidade, { contribuinteId: this.state.inputId });
    //     break;
    //   case "E":
    //     Object.assign(entidade, { cpbsId: this.state.inputId });
    //     break;
    //   case "I":
    //     Object.assign(entidade, { imovelId: this.state.inputId });
    //     break;
    // }

    inserirOuAtualizar(this.cndDs, entidade)
      .then(
        function () {
          notify("CND cadastrada com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.message);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
